import * as Sentry from "@sentry/vue";
import { InitializeSentry as PgInitializeSentry } from "@polargold/pg-frontend-core";
import type { App } from "vue";
import { version } from "../../../package.json";

/**
 * Vue-specific glue around `pg-frontend-core`'s `InitializeSentry`: resolves the shared
 * DSN-gating/sample-rate config, then feeds it to `@sentry/vue`'s own `Sentry.init`.
 * `sendDefaultPii` isn't part of the shared class's resolved config (not every consumer
 * wants it), so it's added here to match this app's original behavior.
 */
export class InitializeSentry {
    public initialize(app: App): void {
        const config = new PgInitializeSentry({
            dsn: import.meta.env.VITE_SENTRY_DSN,
            environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
            release: version,
        }).resolveConfig();

        if (!config) return;

        Sentry.init({
            app,
            ...config,
            sendDefaultPii: true,
        });
    }
}
